import script from "./PaymentProviderTamaro.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentProviderTamaro.vue?vue&type=script&setup=true&lang=js"

import "./PaymentProviderTamaro.vue?vue&type=style&index=0&id=1f4263c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4263c8"]])

export default __exports__